const initialState = () => ({
    data: {},
    loading: false,
    query: {
        dateFrom: null,
        dateTo: null,
        reportType: null,
        filter: null,
    },
});
const ACTION_KEY = 'REPORT';

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${ACTION_KEY}_PDF_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${ACTION_KEY}_PDF_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_PDF_FULFILLED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_PENDING`: {
            return {
                ...state,
                data: null,
                loading: true,
            };
        }
        case `${ACTION_KEY}_REJECTED`: {
            return {
                ...state,
                data: null,
                loading: false,
            };
        }
        case `${ACTION_KEY}_FULFILLED`: {
            const { data, query } = action.payload;
            return {
                ...state,
                loading: false,
                data,
                query,
            };
        }
        case `${ACTION_KEY}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};

export default reducer;
